import api from './api';

const weeklyTimesheetService = {
  // Get all weekly timesheets
  getAllWeeklyTimesheets: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.employeeId) queryParams.append('employeeId', params.employeeId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.year) queryParams.append('year', params.year);
      if (params.weekNumber) queryParams.append('weekNumber', params.weekNumber);

      const queryString = queryParams.toString();
      const url = `/weekly-timesheet${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching weekly timesheets:', error);
      throw error;
    }
  },

  // Get weekly timesheet by ID
  getWeeklyTimesheetById: async (id) => {
    try {
      const response = await api.get(`/weekly-timesheet/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching weekly timesheet:', error);
      throw error;
    }
  },

  // Get next timesheet number
  getNextTimesheetNumber: async () => {
    try {
      const response = await api.get('/weekly-timesheet/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next timesheet number:', error);
      throw error;
    }
  },

  // Get time entries for a week
  getTimeEntriesForWeek: async (employeeId, weekStartDate) => {
    try {
      const response = await api.get('/weekly-timesheet/time-entries/week', {
        params: { employeeId, weekStartDate }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching time entries for week:', error);
      throw error;
    }
  },

  // Create weekly timesheet
  createWeeklyTimesheet: async (timesheetData) => {
    try {
      const response = await api.post('/weekly-timesheet', timesheetData);
      return response.data;
    } catch (error) {
      console.error('Error creating weekly timesheet:', error);
      throw error;
    }
  },

  // Update weekly timesheet
  updateWeeklyTimesheet: async (id, timesheetData) => {
    try {
      const response = await api.put(`/weekly-timesheet/${id}`, timesheetData);
      return response.data;
    } catch (error) {
      console.error('Error updating weekly timesheet:', error);
      throw error;
    }
  },

  // Delete weekly timesheet
  deleteWeeklyTimesheet: async (id) => {
    try {
      const response = await api.delete(`/weekly-timesheet/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting weekly timesheet:', error);
      throw error;
    }
  },

  // Get weekly timesheet statistics
  getWeeklyTimesheetStats: async () => {
    try {
      const response = await api.get('/weekly-timesheet/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching weekly timesheet statistics:', error);
      throw error;
    }
  },

  // Submit timesheet for approval
  submitTimesheetForApproval: async (id, notes) => {
    try {
      const response = await api.put(`/weekly-timesheet/${id}/submit`, { notes });
      return response.data;
    } catch (error) {
      console.error('Error submitting timesheet:', error);
      throw error;
    }
  }
};

export default weeklyTimesheetService;

